import chalk from 'chalk';
import {Command} from 'commander';
import {Listr} from 'listr2';
import prompts from 'prompts';

import {Config, Configured, getConfig, saveConfig} from '@/utilities/config';
import {handleError} from '@/utilities/errors';
import {logger} from '@/utilities/logger';

const packageName = 'Kog';
const commandName = 'kog';

export const configure = new Command()
  .name('configure')
  .description('Configure the GitLab CLI')
  .action(async () => {
    logger.break();
    logger.info(`${chalk.green(packageName)} | CLI tools for GitLab`);
    logger.break();
    logger.info(`${chalk.yellow(`${commandName} configure`)} - configure GitLab credentials`);
    logger.break();

    let config: Config = {
      gitlabUrl: undefined,
      gitlabToken: undefined,
    };

    const onCancel = () => {
      logger.break();
      logger.warn(`${packageName} configuration aborted`);
      process.exit(0);
    };

    try {
      config = await getConfig();

      if (config.gitlabUrl && config.gitlabToken) {
        logger.info('Your GitLab configuration is already set');
        logger.break();

        const response = await prompts(
          {
            type: 'confirm',
            name: 'overwrite',
            message: 'Do you want to update it?',
            initial: false,
          },
          {onCancel}
        );

        if (!response.overwrite) onCancel();
      }
    } catch (e: any) {
      if (e.code !== 'ENOENT') {
        handleError(e);
      }
    }

    const response = await prompts(
      [
        {
          type: 'text',
          name: 'gitlabUrl',
          message: `${config.gitlabUrl ? 'Update' : 'Enter'} your GitLab URL`,
          initial: config.gitlabUrl ?? 'https://gitlab.com',
        },
        {
          type: 'password',
          name: 'gitlabToken',
          message: `${config.gitlabToken ? 'Update' : 'Enter'} your GitLab Personal Access Token (should have \`api\` permission)`,
          initial: config.gitlabToken ?? '',
          validate: (value: string) => (value.length === 0 ? `Token can't be empty` : true),
        },
      ],
      {onCancel}
    );

    const tasks = new Listr([
      {
        title: 'Saving configuration',
        task: () => saveConfig(response as Configured),
      },
    ]);

    try {
      await tasks.run();
    } catch (error) {
      handleError(error);
    }

    logger.break();
    logger.success(`${packageName} configuration successful`);
  });

export default configure;
